module.exports = __webpack_public_path__ + "img/53.21eedd42.jpg";